namespace AgerLMS.LMS {
    export interface OrderAdressRow {
        Id?: number;
        OrderId?: number;
        BillingAddressId?: number;
        ShippingAddressId?: number;
        BillingAddressCityId?: number;
        BillingAddressDistrictId?: number;
        BillingAddress?: string;
        ShippingAddressCityId?: number;
        ShippingAddressDistrictId?: number;
        ShippingAddress?: string;
        InsertDate?: string;
        InsertUserId?: number;
        OrderOrderGuid?: string;
        OrderOrderState?: number;
        OrderConfirmDate?: string;
        OrderConfirmUserId?: number;
        OrderInsertDate?: string;
        OrderInsertUserId?: number;
        OrderPrice?: number;
        OrderPaidPrice?: number;
        OrderDiscountId?: number;
        OrderDistanceSalesAgreement?: string;
        OrderCargoCompanyId?: number;
        OrderCargoTrackingNumber?: string;
        OrderCargoPrice?: number;
        OrderCargoDate?: string;
        OrderCargoUserId?: number;
        OrderProvinceId?: number;
        OrderPaymentType?: number;
        OrderCustomerId?: number;
        OrderManuelOrder?: number[];
        OrderInstallment?: number;
        OrderBillingAddress?: string;
        OrderShippingAddress?: string;
        OrderCargoId?: number;
        BillingAddressTitle?: string;
        BillingAddressCityId1?: number;
        BillingAddressDistrictId1?: number;
        BillingAddressNeighbourhoodId?: number;
        BillingAddressAddress1?: string;
        BillingAddressAddress2?: string;
        BillingAddressInsertDate?: string;
        BillingAddressInsertUserId?: number;
        BillingAddressUpdateDate?: string;
        BillingAddressUpdateUserId?: number;
        BillingAddressIsActive?: number;
        BillingAddressUserId?: number;
        BillingAddressIsDefaultShippingAddress?: number[];
        BillingAddressIsDefaultBillingAddress?: number[];
        BillingAddressZipCode?: string;
        ShippingAddressTitle?: string;
        ShippingAddressCityId1?: number;
        ShippingAddressDistrictId1?: number;
        ShippingAddressNeighbourhoodId?: number;
        ShippingAddressAddress1?: string;
        ShippingAddressAddress2?: string;
        ShippingAddressInsertDate?: string;
        ShippingAddressInsertUserId?: number;
        ShippingAddressUpdateDate?: string;
        ShippingAddressUpdateUserId?: number;
        ShippingAddressIsActive?: number;
        ShippingAddressUserId?: number;
        ShippingAddressIsDefaultShippingAddress?: number[];
        ShippingAddressIsDefaultBillingAddress?: number[];
        ShippingAddressZipCode?: string;
        BillingAddressCityName?: string;
        BillingAddressDistrictName?: string;
    }

    export namespace OrderAdressRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'LMS.OrderAdress';
        export const deletePermission = 'OrderAdress';
        export const insertPermission = 'OrderAdress';
        export const readPermission = 'OrderAdress';
        export const updatePermission = 'OrderAdress';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            BillingAddressId = "BillingAddressId",
            ShippingAddressId = "ShippingAddressId",
            BillingAddressCityId = "BillingAddressCityId",
            BillingAddressDistrictId = "BillingAddressDistrictId",
            BillingAddress = "BillingAddress",
            ShippingAddressCityId = "ShippingAddressCityId",
            ShippingAddressDistrictId = "ShippingAddressDistrictId",
            ShippingAddress = "ShippingAddress",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            OrderOrderGuid = "OrderOrderGuid",
            OrderOrderState = "OrderOrderState",
            OrderConfirmDate = "OrderConfirmDate",
            OrderConfirmUserId = "OrderConfirmUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderInsertUserId = "OrderInsertUserId",
            OrderPrice = "OrderPrice",
            OrderPaidPrice = "OrderPaidPrice",
            OrderDiscountId = "OrderDiscountId",
            OrderDistanceSalesAgreement = "OrderDistanceSalesAgreement",
            OrderCargoCompanyId = "OrderCargoCompanyId",
            OrderCargoTrackingNumber = "OrderCargoTrackingNumber",
            OrderCargoPrice = "OrderCargoPrice",
            OrderCargoDate = "OrderCargoDate",
            OrderCargoUserId = "OrderCargoUserId",
            OrderProvinceId = "OrderProvinceId",
            OrderPaymentType = "OrderPaymentType",
            OrderCustomerId = "OrderCustomerId",
            OrderManuelOrder = "OrderManuelOrder",
            OrderInstallment = "OrderInstallment",
            OrderBillingAddress = "OrderBillingAddress",
            OrderShippingAddress = "OrderShippingAddress",
            OrderCargoId = "OrderCargoId",
            BillingAddressTitle = "BillingAddressTitle",
            BillingAddressCityId1 = "BillingAddressCityId1",
            BillingAddressDistrictId1 = "BillingAddressDistrictId1",
            BillingAddressNeighbourhoodId = "BillingAddressNeighbourhoodId",
            BillingAddressAddress1 = "BillingAddressAddress1",
            BillingAddressAddress2 = "BillingAddressAddress2",
            BillingAddressInsertDate = "BillingAddressInsertDate",
            BillingAddressInsertUserId = "BillingAddressInsertUserId",
            BillingAddressUpdateDate = "BillingAddressUpdateDate",
            BillingAddressUpdateUserId = "BillingAddressUpdateUserId",
            BillingAddressIsActive = "BillingAddressIsActive",
            BillingAddressUserId = "BillingAddressUserId",
            BillingAddressIsDefaultShippingAddress = "BillingAddressIsDefaultShippingAddress",
            BillingAddressIsDefaultBillingAddress = "BillingAddressIsDefaultBillingAddress",
            BillingAddressZipCode = "BillingAddressZipCode",
            ShippingAddressTitle = "ShippingAddressTitle",
            ShippingAddressCityId1 = "ShippingAddressCityId1",
            ShippingAddressDistrictId1 = "ShippingAddressDistrictId1",
            ShippingAddressNeighbourhoodId = "ShippingAddressNeighbourhoodId",
            ShippingAddressAddress1 = "ShippingAddressAddress1",
            ShippingAddressAddress2 = "ShippingAddressAddress2",
            ShippingAddressInsertDate = "ShippingAddressInsertDate",
            ShippingAddressInsertUserId = "ShippingAddressInsertUserId",
            ShippingAddressUpdateDate = "ShippingAddressUpdateDate",
            ShippingAddressUpdateUserId = "ShippingAddressUpdateUserId",
            ShippingAddressIsActive = "ShippingAddressIsActive",
            ShippingAddressUserId = "ShippingAddressUserId",
            ShippingAddressIsDefaultShippingAddress = "ShippingAddressIsDefaultShippingAddress",
            ShippingAddressIsDefaultBillingAddress = "ShippingAddressIsDefaultBillingAddress",
            ShippingAddressZipCode = "ShippingAddressZipCode",
            BillingAddressCityName = "BillingAddressCityName",
            BillingAddressDistrictName = "BillingAddressDistrictName"
        }
    }
}
